"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoTestRedactedSelectAllQuestionAnswersValueHints = exports.AutoTestRedactedRunInNotebookInsertMethod = exports.AutoTestRedactedRunIfCondition = exports.AutoTestRedactedWhitespacesPolicy = exports.AutoTestRedactedCaseSensitivity = exports.AutoTestRedactedJunit5TestFile = exports.AutoTestRedactedFlake8Version = exports.AutoTestRedactedInteger = exports.AutoTestRedactedCodeStructureTestVersion = exports.AutoTestRedactedCheckstyleVersion = exports.AutoTestRedactedDeductions = exports.AutoTestRedactedString = exports.AutoTestOverwriteRubric = exports.ValidationError = exports.NotFoundError = exports.NotAuthorizedError = exports.NotAuthenticatedError = exports.InternalServerError = exports.BadRequestError = exports.BadRequestErrorReason = exports.AutoTestTestHideWhen = exports.AutoTestTestHidePreposition = exports.AutoTestTestHideHideType = exports.AutoTestRunInNotebookInsertMethod = exports.AutoTestRunInEnvironment = exports.AutoTestRunIfConditionType = exports.AutoTestWhitespacesPolicy = exports.AutoTestCaseSensitivity = exports.AutoTestQuizViewMode = exports.AutoTestQuizAnswerOrder = exports.AutoTestJupyterNotebookRunPermission = exports.AutoTestJunit5Version = exports.AutoTestCheckstyleVersion = exports.AutoTestSnapshotSource = exports.AutoTestSnapshotBuildProgramState = exports.AutoTestAutoInstallStepOutput = exports.AutoTestPytestVersion = exports.AutoTestJupyterNotebookPython3KernelVersion = exports.AutoTestJupyterNotebookKernel = exports.AutoTestFlake8Version = exports.AutoTestCodeStructureTestVersion = exports.AutoTestSetupStepOutput = exports.AutoTestDescriptionBehavior = exports.AutoTestInstallPythonVersion = exports.AutoTestInstallNodeVersion = exports.AutoTestInstallJavaVersion = exports.AutoTestInstallGccVersion = exports.AutoTestInstallDotnetVersion = exports.AutoTestInstallClangVersion = exports.AutoTestPublishedSnapshotId = void 0;
exports.PearsonQuestionData = exports.PearsonSelectAllQuestionAnswerOrder = exports.PearsonMultipleChoiceQuestionAnswerOrder = exports.NumberOfAttempts = exports.SafeProgramSource = exports.InputFileType = exports.OuptutRegularFileType = exports.EditorSessionSource = exports.JupyterOutputEvent = exports.JupyterStreamOutputEventValue = exports.JupyterMimeOutputDataEventValue = exports.JupyterKernelStatus = exports.AssistantStatus = exports.AssistantFeature = exports.AssistantData = exports.AssistantMessageData = exports.AssistantMessageUserContent = exports.User = exports.AssistantMessageStopReason = exports.AssistantMessageAssistantContent = exports.AutoTestSetupStepInput = exports.AutoTestRedactedFraction = exports.AutoTestRedactedUploadedFilesOutput = exports.AutoTestRedactedPositiveDuration = exports.AutoTestRedactedBoolean = void 0;
const Apiv2ServiceException_1 = require("./Apiv2ServiceException");
var AutoTestPublishedSnapshotId;
(function (AutoTestPublishedSnapshotId) {
    AutoTestPublishedSnapshotId.visit = (value, visitor) => {
        if (value.unpublished !== undefined)
            return visitor.unpublished(value.unpublished);
        if (value.published !== undefined)
            return visitor.published(value.published);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestPublishedSnapshotId || (exports.AutoTestPublishedSnapshotId = AutoTestPublishedSnapshotId = {}));
exports.AutoTestInstallClangVersion = {
    V_12: "12",
    V_16: "16",
};
exports.AutoTestInstallDotnetVersion = {
    V_6_0: "6.0",
    V_7_0: "7.0",
    V_8_0: "8.0",
    V_9_0: "9.0",
};
exports.AutoTestInstallGccVersion = {
    V_10: "10",
    V_13: "13",
    V_9: "9",
};
exports.AutoTestInstallJavaVersion = {
    V_11: "11",
    V_17: "17",
    V_21: "21",
    V_8: "8",
};
exports.AutoTestInstallNodeVersion = {
    V_14: "14",
    V_16: "16",
    V_18: "18",
};
exports.AutoTestInstallPythonVersion = {
    V_3_10: "3.10",
    V_3_11: "3.11",
    V_3_12: "3.12",
    V_3_13: "3.13",
    V_PYPY3_10_7_3_12: "pypy3.10 - 7.3.12",
};
exports.AutoTestDescriptionBehavior = {
    COLLAPSE: "collapse",
    UNCOLLAPSE: "uncollapse",
    UNCOLLAPSE_ON_FAIL: "uncollapse-on-fail",
};
var AutoTestSetupStepOutput;
(function (AutoTestSetupStepOutput) {
    AutoTestSetupStepOutput.visit = (value, visitor) => {
        if (value.installDotnet !== undefined)
            return visitor.installDotnet(value.installDotnet);
        if (value.installJava !== undefined)
            return visitor.installJava(value.installJava);
        if (value.installPython !== undefined)
            return visitor.installPython(value.installPython);
        if (value.installNode !== undefined)
            return visitor.installNode(value.installNode);
        if (value.uploadFiles !== undefined)
            return visitor.uploadFiles(value.uploadFiles);
        if (value.installClang !== undefined)
            return visitor.installClang(value.installClang);
        if (value.installGcc !== undefined)
            return visitor.installGcc(value.installGcc);
        if (value.script !== undefined)
            return visitor.script(value.script);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestSetupStepOutput || (exports.AutoTestSetupStepOutput = AutoTestSetupStepOutput = {}));
exports.AutoTestCodeStructureTestVersion = {
    V_1_132_0: "1.132.0",
    V_1_43_0: "1.43.0",
};
exports.AutoTestFlake8Version = {
    V_6_0_0: "6.0.0",
};
exports.AutoTestJupyterNotebookKernel = {
    PYTHON_3: "Python 3",
};
exports.AutoTestJupyterNotebookPython3KernelVersion = {
    V_6_29_5: "6.29.5",
};
exports.AutoTestPytestVersion = {
    V_7_3_1: "7.3.1",
    V_7_4_4: "7.4.4",
    V_8_3_3: "8.3.3",
};
var AutoTestAutoInstallStepOutput;
(function (AutoTestAutoInstallStepOutput) {
    AutoTestAutoInstallStepOutput.visit = (value, visitor) => {
        if (value.autoInstallFlake8 !== undefined)
            return visitor.autoInstallFlake8(value.autoInstallFlake8);
        if (value.autoInstallPytest !== undefined)
            return visitor.autoInstallPytest(value.autoInstallPytest);
        if (value.autoInstallCodeStructureTest !== undefined)
            return visitor.autoInstallCodeStructureTest(value.autoInstallCodeStructureTest);
        if (value.autoInstallSimplePythonTest !== undefined)
            return visitor.autoInstallSimplePythonTest(value.autoInstallSimplePythonTest);
        if (value.autoInstallJupyterNotebook !== undefined)
            return visitor.autoInstallJupyterNotebook(value.autoInstallJupyterNotebook);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestAutoInstallStepOutput || (exports.AutoTestAutoInstallStepOutput = AutoTestAutoInstallStepOutput = {}));
exports.AutoTestSnapshotBuildProgramState = {
    ERRORED: "errored",
    FINISHED: "finished",
    RUNNING: "running",
    WAITING_TO_START: "waiting-to-start",
};
var AutoTestSnapshotSource;
(function (AutoTestSnapshotSource) {
    AutoTestSnapshotSource.visit = (value, visitor) => {
        if (value.ran !== undefined)
            return visitor.ran(value.ran);
        if (value.copied !== undefined)
            return visitor.copied(value.copied);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestSnapshotSource || (exports.AutoTestSnapshotSource = AutoTestSnapshotSource = {}));
exports.AutoTestCheckstyleVersion = {
    V_10_12_3: "10.12.3",
    V_9_3: "9.3",
};
exports.AutoTestJunit5Version = {
    V_1_10_0: "1.10.0",
    V_1_8_2: "1.8.2",
};
exports.AutoTestJupyterNotebookRunPermission = {
    DISABLED: "disabled",
    ENABLED: "enabled",
};
exports.AutoTestQuizAnswerOrder = {
    INDEX_ORDER: "index-order",
    RANDOM_ORDER: "random-order",
};
exports.AutoTestQuizViewMode = {
    MULTI_PAGE: "multi-page",
    SINGLE_PAGE: "single-page",
};
exports.AutoTestCaseSensitivity = {
    INSENSITIVE: "insensitive",
    SENSITIVE: "sensitive",
};
exports.AutoTestWhitespacesPolicy = {
    IGNORE: "ignore",
    INCLUDE: "include",
};
exports.AutoTestRunIfConditionType = {
    RUBRIC_PERCENTAGE_MET: "rubric-percentage-met",
    RUBRIC_PERCENTAGE_NOT_MET: "rubric-percentage-not-met",
};
exports.AutoTestRunInEnvironment = {
    AUTO_TEST: "auto-test",
    CODE_EDITOR: "code-editor",
    EVERYWHERE: "everywhere",
};
exports.AutoTestRunInNotebookInsertMethod = {
    AFTER_CELL: "after-cell",
    APPEND_TO_NOTEBOOK: "append-to-notebook",
    BEFORE_CELL: "before-cell",
    PREPEND_TO_NOTEBOOK: "prepend-to-notebook",
};
exports.AutoTestTestHideHideType = {
    CONFIG: "config",
    OUTPUT: "output",
    RESULT: "result",
};
exports.AutoTestTestHidePreposition = {
    AFTER: "after",
    ALWAYS: "always",
    BEFORE: "before",
};
exports.AutoTestTestHideWhen = {
    DEADLINE: "deadline",
    LOCKDATE: "lockdate",
};
var BadRequestErrorReason;
(function (BadRequestErrorReason) {
    BadRequestErrorReason.visit = (value, visitor) => {
        if (value.wrongItemCount !== undefined)
            return visitor.wrongItemCount(value.wrongItemCount);
        if (value.unknownEnumType !== undefined)
            return visitor.unknownEnumType(value.unknownEnumType);
        if (value.invalidState !== undefined)
            return visitor.invalidState(value.invalidState);
        if (value.invalidParam !== undefined)
            return visitor.invalidParam(value.invalidParam);
        if (value.inexplicitRubricOverwrite !== undefined)
            return visitor.inexplicitRubricOverwrite(value.inexplicitRubricOverwrite);
        if (value.ignoreNonInteractedQuestions !== undefined)
            return visitor.ignoreNonInteractedQuestions(value.ignoreNonInteractedQuestions);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(BadRequestErrorReason || (exports.BadRequestErrorReason = BadRequestErrorReason = {}));
class BadRequestError extends Apiv2ServiceException_1.Apiv2ServiceException {
    name = "BadRequestError";
    $fault = "client";
    description;
    requestId;
    reason;
    constructor(opts) {
        super({
            name: "BadRequestError",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, BadRequestError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
        this.reason = opts.reason;
    }
}
exports.BadRequestError = BadRequestError;
class InternalServerError extends Apiv2ServiceException_1.Apiv2ServiceException {
    name = "InternalServerError";
    $fault = "server";
    description;
    requestId;
    constructor(opts) {
        super({
            name: "InternalServerError",
            $fault: "server",
            ...opts
        });
        Object.setPrototypeOf(this, InternalServerError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
    }
}
exports.InternalServerError = InternalServerError;
class NotAuthenticatedError extends Apiv2ServiceException_1.Apiv2ServiceException {
    name = "NotAuthenticatedError";
    $fault = "client";
    description;
    requestId;
    constructor(opts) {
        super({
            name: "NotAuthenticatedError",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, NotAuthenticatedError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
    }
}
exports.NotAuthenticatedError = NotAuthenticatedError;
class NotAuthorizedError extends Apiv2ServiceException_1.Apiv2ServiceException {
    name = "NotAuthorizedError";
    $fault = "client";
    description;
    requestId;
    resource;
    operation;
    constructor(opts) {
        super({
            name: "NotAuthorizedError",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, NotAuthorizedError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
        this.resource = opts.resource;
        this.operation = opts.operation;
    }
}
exports.NotAuthorizedError = NotAuthorizedError;
class NotFoundError extends Apiv2ServiceException_1.Apiv2ServiceException {
    name = "NotFoundError";
    $fault = "client";
    description;
    requestId;
    resource;
    constructor(opts) {
        super({
            name: "NotFoundError",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, NotFoundError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
        this.resource = opts.resource;
    }
}
exports.NotFoundError = NotFoundError;
class ValidationError extends Apiv2ServiceException_1.Apiv2ServiceException {
    name = "ValidationError";
    $fault = "client";
    description;
    requestId;
    fieldList;
    constructor(opts) {
        super({
            name: "ValidationError",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, ValidationError.prototype);
        this.description = opts.description;
        this.requestId = opts.requestId;
        this.fieldList = opts.fieldList;
    }
}
exports.ValidationError = ValidationError;
var AutoTestOverwriteRubric;
(function (AutoTestOverwriteRubric) {
    AutoTestOverwriteRubric.visit = (value, visitor) => {
        if (value.doOverwrite !== undefined)
            return visitor.doOverwrite(value.doOverwrite);
        if (value.doNotOverwrite !== undefined)
            return visitor.doNotOverwrite(value.doNotOverwrite);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestOverwriteRubric || (exports.AutoTestOverwriteRubric = AutoTestOverwriteRubric = {}));
var AutoTestRedactedString;
(function (AutoTestRedactedString) {
    AutoTestRedactedString.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedString || (exports.AutoTestRedactedString = AutoTestRedactedString = {}));
var AutoTestRedactedDeductions;
(function (AutoTestRedactedDeductions) {
    AutoTestRedactedDeductions.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedDeductions || (exports.AutoTestRedactedDeductions = AutoTestRedactedDeductions = {}));
var AutoTestRedactedCheckstyleVersion;
(function (AutoTestRedactedCheckstyleVersion) {
    AutoTestRedactedCheckstyleVersion.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedCheckstyleVersion || (exports.AutoTestRedactedCheckstyleVersion = AutoTestRedactedCheckstyleVersion = {}));
var AutoTestRedactedCodeStructureTestVersion;
(function (AutoTestRedactedCodeStructureTestVersion) {
    AutoTestRedactedCodeStructureTestVersion.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedCodeStructureTestVersion || (exports.AutoTestRedactedCodeStructureTestVersion = AutoTestRedactedCodeStructureTestVersion = {}));
var AutoTestRedactedInteger;
(function (AutoTestRedactedInteger) {
    AutoTestRedactedInteger.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedInteger || (exports.AutoTestRedactedInteger = AutoTestRedactedInteger = {}));
var AutoTestRedactedFlake8Version;
(function (AutoTestRedactedFlake8Version) {
    AutoTestRedactedFlake8Version.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedFlake8Version || (exports.AutoTestRedactedFlake8Version = AutoTestRedactedFlake8Version = {}));
var AutoTestRedactedJunit5TestFile;
(function (AutoTestRedactedJunit5TestFile) {
    AutoTestRedactedJunit5TestFile.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedJunit5TestFile || (exports.AutoTestRedactedJunit5TestFile = AutoTestRedactedJunit5TestFile = {}));
var AutoTestRedactedCaseSensitivity;
(function (AutoTestRedactedCaseSensitivity) {
    AutoTestRedactedCaseSensitivity.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedCaseSensitivity || (exports.AutoTestRedactedCaseSensitivity = AutoTestRedactedCaseSensitivity = {}));
var AutoTestRedactedWhitespacesPolicy;
(function (AutoTestRedactedWhitespacesPolicy) {
    AutoTestRedactedWhitespacesPolicy.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedWhitespacesPolicy || (exports.AutoTestRedactedWhitespacesPolicy = AutoTestRedactedWhitespacesPolicy = {}));
var AutoTestRedactedRunIfCondition;
(function (AutoTestRedactedRunIfCondition) {
    AutoTestRedactedRunIfCondition.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedRunIfCondition || (exports.AutoTestRedactedRunIfCondition = AutoTestRedactedRunIfCondition = {}));
var AutoTestRedactedRunInNotebookInsertMethod;
(function (AutoTestRedactedRunInNotebookInsertMethod) {
    AutoTestRedactedRunInNotebookInsertMethod.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedRunInNotebookInsertMethod || (exports.AutoTestRedactedRunInNotebookInsertMethod = AutoTestRedactedRunInNotebookInsertMethod = {}));
var AutoTestRedactedSelectAllQuestionAnswersValueHints;
(function (AutoTestRedactedSelectAllQuestionAnswersValueHints) {
    AutoTestRedactedSelectAllQuestionAnswersValueHints.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedSelectAllQuestionAnswersValueHints || (exports.AutoTestRedactedSelectAllQuestionAnswersValueHints = AutoTestRedactedSelectAllQuestionAnswersValueHints = {}));
var AutoTestRedactedBoolean;
(function (AutoTestRedactedBoolean) {
    AutoTestRedactedBoolean.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedBoolean || (exports.AutoTestRedactedBoolean = AutoTestRedactedBoolean = {}));
var AutoTestRedactedPositiveDuration;
(function (AutoTestRedactedPositiveDuration) {
    AutoTestRedactedPositiveDuration.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedPositiveDuration || (exports.AutoTestRedactedPositiveDuration = AutoTestRedactedPositiveDuration = {}));
var AutoTestRedactedUploadedFilesOutput;
(function (AutoTestRedactedUploadedFilesOutput) {
    AutoTestRedactedUploadedFilesOutput.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedUploadedFilesOutput || (exports.AutoTestRedactedUploadedFilesOutput = AutoTestRedactedUploadedFilesOutput = {}));
var AutoTestRedactedFraction;
(function (AutoTestRedactedFraction) {
    AutoTestRedactedFraction.visit = (value, visitor) => {
        if (value.redacted !== undefined)
            return visitor.redacted(value.redacted);
        if (value.unredacted !== undefined)
            return visitor.unredacted(value.unredacted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestRedactedFraction || (exports.AutoTestRedactedFraction = AutoTestRedactedFraction = {}));
var AutoTestSetupStepInput;
(function (AutoTestSetupStepInput) {
    AutoTestSetupStepInput.visit = (value, visitor) => {
        if (value.installDotnet !== undefined)
            return visitor.installDotnet(value.installDotnet);
        if (value.installJava !== undefined)
            return visitor.installJava(value.installJava);
        if (value.installPython !== undefined)
            return visitor.installPython(value.installPython);
        if (value.installNode !== undefined)
            return visitor.installNode(value.installNode);
        if (value.uploadFiles !== undefined)
            return visitor.uploadFiles(value.uploadFiles);
        if (value.installClang !== undefined)
            return visitor.installClang(value.installClang);
        if (value.installGcc !== undefined)
            return visitor.installGcc(value.installGcc);
        if (value.script !== undefined)
            return visitor.script(value.script);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AutoTestSetupStepInput || (exports.AutoTestSetupStepInput = AutoTestSetupStepInput = {}));
var AssistantMessageAssistantContent;
(function (AssistantMessageAssistantContent) {
    AssistantMessageAssistantContent.visit = (value, visitor) => {
        if (value.text !== undefined)
            return visitor.text(value.text);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantMessageAssistantContent || (exports.AssistantMessageAssistantContent = AssistantMessageAssistantContent = {}));
var AssistantMessageStopReason;
(function (AssistantMessageStopReason) {
    AssistantMessageStopReason.visit = (value, visitor) => {
        if (value.endTurn !== undefined)
            return visitor.endTurn(value.endTurn);
        if (value.maxTokens !== undefined)
            return visitor.maxTokens(value.maxTokens);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantMessageStopReason || (exports.AssistantMessageStopReason = AssistantMessageStopReason = {}));
var User;
(function (User) {
    User.visit = (value, visitor) => {
        if (value.group !== undefined)
            return visitor.group(value.group);
        if (value.normal !== undefined)
            return visitor.normal(value.normal);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(User || (exports.User = User = {}));
var AssistantMessageUserContent;
(function (AssistantMessageUserContent) {
    AssistantMessageUserContent.visit = (value, visitor) => {
        if (value.text !== undefined)
            return visitor.text(value.text);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantMessageUserContent || (exports.AssistantMessageUserContent = AssistantMessageUserContent = {}));
var AssistantMessageData;
(function (AssistantMessageData) {
    AssistantMessageData.visit = (value, visitor) => {
        if (value.user !== undefined)
            return visitor.user(value.user);
        if (value.assistant !== undefined)
            return visitor.assistant(value.assistant);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantMessageData || (exports.AssistantMessageData = AssistantMessageData = {}));
var AssistantData;
(function (AssistantData) {
    AssistantData.visit = (value, visitor) => {
        if (value.assignment !== undefined)
            return visitor.assignment(value.assignment);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantData || (exports.AssistantData = AssistantData = {}));
exports.AssistantFeature = {
    ACCESS_TO_PAGE: "ACCESS_TO_PAGE",
};
var AssistantStatus;
(function (AssistantStatus) {
    AssistantStatus.visit = (value, visitor) => {
        if (value.enabled !== undefined)
            return visitor.enabled(value.enabled);
        if (value.disabled !== undefined)
            return visitor.disabled(value.disabled);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(AssistantStatus || (exports.AssistantStatus = AssistantStatus = {}));
var JupyterKernelStatus;
(function (JupyterKernelStatus) {
    JupyterKernelStatus.visit = (value, visitor) => {
        if (value.alive !== undefined)
            return visitor.alive(value.alive);
        if (value.dead !== undefined)
            return visitor.dead(value.dead);
        if (value.starting !== undefined)
            return visitor.starting(value.starting);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(JupyterKernelStatus || (exports.JupyterKernelStatus = JupyterKernelStatus = {}));
var JupyterMimeOutputDataEventValue;
(function (JupyterMimeOutputDataEventValue) {
    JupyterMimeOutputDataEventValue.visit = (value, visitor) => {
        if (value.inline !== undefined)
            return visitor.inline(value.inline);
        if (value.link !== undefined)
            return visitor.link(value.link);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(JupyterMimeOutputDataEventValue || (exports.JupyterMimeOutputDataEventValue = JupyterMimeOutputDataEventValue = {}));
var JupyterStreamOutputEventValue;
(function (JupyterStreamOutputEventValue) {
    JupyterStreamOutputEventValue.visit = (value, visitor) => {
        if (value.inline !== undefined)
            return visitor.inline(value.inline);
        if (value.link !== undefined)
            return visitor.link(value.link);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(JupyterStreamOutputEventValue || (exports.JupyterStreamOutputEventValue = JupyterStreamOutputEventValue = {}));
var JupyterOutputEvent;
(function (JupyterOutputEvent) {
    JupyterOutputEvent.visit = (value, visitor) => {
        if (value.executeStart !== undefined)
            return visitor.executeStart(value.executeStart);
        if (value.stream !== undefined)
            return visitor.stream(value.stream);
        if (value.displayData !== undefined)
            return visitor.displayData(value.displayData);
        if (value.executeResult !== undefined)
            return visitor.executeResult(value.executeResult);
        if (value.error !== undefined)
            return visitor.error(value.error);
        if (value.executeRequested !== undefined)
            return visitor.executeRequested(value.executeRequested);
        if (value.executeInterrupted !== undefined)
            return visitor.executeInterrupted(value.executeInterrupted);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(JupyterOutputEvent || (exports.JupyterOutputEvent = JupyterOutputEvent = {}));
var EditorSessionSource;
(function (EditorSessionSource) {
    EditorSessionSource.visit = (value, visitor) => {
        if (value.template !== undefined)
            return visitor.template(value.template);
        if (value.submission !== undefined)
            return visitor.submission(value.submission);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(EditorSessionSource || (exports.EditorSessionSource = EditorSessionSource = {}));
var OuptutRegularFileType;
(function (OuptutRegularFileType) {
    OuptutRegularFileType.visit = (value, visitor) => {
        if (value.text !== undefined)
            return visitor.text(value.text);
        if (value.binary !== undefined)
            return visitor.binary(value.binary);
        if (value.quiz !== undefined)
            return visitor.quiz(value.quiz);
        if (value.notebook !== undefined)
            return visitor.notebook(value.notebook);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(OuptutRegularFileType || (exports.OuptutRegularFileType = OuptutRegularFileType = {}));
var InputFileType;
(function (InputFileType) {
    InputFileType.visit = (value, visitor) => {
        if (value.directory !== undefined)
            return visitor.directory(value.directory);
        if (value.regular !== undefined)
            return visitor.regular(value.regular);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(InputFileType || (exports.InputFileType = InputFileType = {}));
var SafeProgramSource;
(function (SafeProgramSource) {
    SafeProgramSource.visit = (value, visitor) => {
        if (value.pearsonQuestion !== undefined)
            return visitor.pearsonQuestion(value.pearsonQuestion);
        if (value.singleQuizQuestion !== undefined)
            return visitor.singleQuizQuestion(value.singleQuizQuestion);
        if (value.submission !== undefined)
            return visitor.submission(value.submission);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(SafeProgramSource || (exports.SafeProgramSource = SafeProgramSource = {}));
var NumberOfAttempts;
(function (NumberOfAttempts) {
    NumberOfAttempts.visit = (value, visitor) => {
        if (value.unlimited !== undefined)
            return visitor.unlimited(value.unlimited);
        if (value.limited !== undefined)
            return visitor.limited(value.limited);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(NumberOfAttempts || (exports.NumberOfAttempts = NumberOfAttempts = {}));
exports.PearsonMultipleChoiceQuestionAnswerOrder = {
    INDEX_ORDER: "index-order",
    RANDOM_ORDER: "random-order",
};
exports.PearsonSelectAllQuestionAnswerOrder = {
    INDEX_ORDER: "index-order",
    RANDOM_ORDER: "random-order",
};
var PearsonQuestionData;
(function (PearsonQuestionData) {
    PearsonQuestionData.visit = (value, visitor) => {
        if (value.coding !== undefined)
            return visitor.coding(value.coding);
        if (value.multipleChoice !== undefined)
            return visitor.multipleChoice(value.multipleChoice);
        if (value.selectAll !== undefined)
            return visitor.selectAll(value.selectAll);
        return visitor._(value.$unknown[0], value.$unknown[1]);
    };
})(PearsonQuestionData || (exports.PearsonQuestionData = PearsonQuestionData = {}));
